<script lang="ts">
	import { DropdownMenu as DropdownMenuPrimitive } from "bits-ui";
	import { cn, type WithoutChildrenOrChild } from "$lib/utils.js";
	import type { ComponentProps } from "svelte";

	let {
		ref = $bindable(null),
		class: className,
		sideOffset = 4,
		side = "bottom",
		align = "start",
		children,
		portalProps,
		...restProps
	}: DropdownMenuPrimitive.ContentProps & {
		portalProps?: WithoutChildrenOrChild<ComponentProps<typeof DropdownMenuPrimitive.Portal>>;
	} = $props();
</script>

<!-- Open WebUI DropdownMenu chrome: a rounded-xl card with a 2px inner inset,
     hairline border, shadow-lg, on white / gray-850. Items are 27px rows. -->
<DropdownMenuPrimitive.Portal {...portalProps}>
	<DropdownMenuPrimitive.Content
		bind:ref
		data-slot="dropdown-menu-content"
		{sideOffset}
		{side}
		{align}
		class={cn(
			"data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2 motion-reduce:animate-none motion-reduce:transition-none z-50 min-w-[10.625rem] origin-(--bits-dropdown-menu-content-transform-origin) rounded-xl border border-gray-100 bg-white p-0.5 text-[0.8125rem] text-gray-700 shadow-lg outline-hidden select-none dark:border-gray-800 dark:bg-gray-850 dark:text-white",
			className
		)}
		{...restProps}
	>
		{@render children?.()}
	</DropdownMenuPrimitive.Content>
</DropdownMenuPrimitive.Portal>
